import React from 'react';
import SubHeader from '../../../layout/components/SubHeader';
import ReminderCard from './tabcards/ReminderCard';
import './ReminderSettings.css';

function ReminderSettings() {
    return (
        <div className="ecx-page clinic-settings-page reminder-settings-page ecx-page--full-width">
            <SubHeader
                title="Clinic Reminders"
                description="Manage your clinic's reminder preferences and notification settings"
                icon="bi-bell"
                containerClass="w-100 px-4"
            />

            <div className="ecx-page-body">
                <ReminderCard />
            </div>
        </div>
    );
}

export default ReminderSettings;
